<template>
  <div
    ref="winning"
    v-loading="drawLoading"
    class="m-winning-wrap"
  >
    <div class="pop-winning">
      <!-- top -->
      <div class="pop-winning-top">
        <img
          src="../images/winning/cup.png"
          class="cup"
        >
        <img
          src="../images/winning/title.png"
          class="title"
        >
      </div>
      <!-- main  -->
      <div class="pop-winning-main">
        <p class="amount">
          {{ $t('CURRENCY') }} <span class="amount-con">{{ showWinnings }}</span>
        </p>
        <p class="desc">
          From {{ fromTypeText }}, Ticket ID: {{ shortId }}
        </p>

        <!-- button -->
        <div class="pop-winning-button">
          <VButton
            v-if="isShowCheckDetail"
            class="check"
            @click="checkDetails"
          >
            CHECK DETAILS
          </VButton>
          <VButton
            v-if="hasShowOff"
            class="show"
            @click="handleShowOff(false)"
          >
            SHOW OFF
          </VButton>
        </div>

        <!-- close -->
        <div
          class="close"
          @click="closeDialog"
        >
          <svg-icon icon-class="icon-png-x" />
        </div>

        <div class="pop-winning-bot">
          <div
            v-if="hasShowOff && online"
            class="m-share-stake-back"
            @click="handleShowOff(true)"
          >
            <p>Tap and Get Stake Back Up to {{ $t('CURRENCY_UNIT') }}{{ $t('stakeBackUp') }}</p>
            <div class="myBets-stake-back-img">
              <img src="~wap/common/images/stake-back.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- bg -->
    <Coins
      v-for="i in 6"
      :key="i"
      :class="'pop-winning-coins'+i"
      :delay-time="delayTimeList[i-1]"
      :rotate-deg="rotateNumList[i-1]"
    />

    <!-- 绘图元素 -->
    <ShareWinning
      ref="shareContainer"
      :from-type-text="fromTypeText"
      :short-id="shortId"
      :show-winnings="showWinnings"
      :hide-mount="hideAmount"
    />

    <!-- stake back 分享的是订单的 -->
    <ShareTicket
      ref="shareContainer2"
      :order-detail="resOrderDetail"
      :show-footer-buttons="false"
      :hide-amount="hideAmount"
      is-share
    />

    <!-- 分享到 top list 的行为由跳转后判断，这里不像 orderDetail 做前置判断 -->
    <Share
      v-model="shareVisible"
      :share-top-tips="shareTopTips"
      :share-imgs="shareImgs"
      :channel-prefix="isStakeShare ? 'promo_share_winnings' : 'share_winnings'"
      :share-url="shareUrl"
      :share-text="shareText"
      :callback-before-share="callbackBeforeShare"
      :hide-amount-checked="hideAmountChecked"
      :default-hide-amount="hideAmountChecked"
      :order-id="orderId"
      :class="['m-winning-share',{'none-pad':isStakeShare}]"
      has-top-list
      :can-top-list-share="canTopListShare"
      @close="onCloseShare"
      @hide-amount="onHideAmount"
    >
      <div
        v-if="shareVisible && isStakeShare"
        slot="share-top"
        class="m-share-order"
      >
        <div class="m-share-order-title">
          Share to Your Friends!
        </div>
        <div class="m-share-order-content">
          Every time a new bet is placed through the <span class="light">SHARED LINK</span>, 1% stake of the new bet will be refunded to you! Until you get all the stake back!
        </div>
        <div class="m-share-order-tip">
          <svg-icon icon-class="icon-gantanhao" />Each Customer can only follow 1 bet once!
        </div>
      </div>

      <div
        v-if="shareVisible && isStakeShare"
        slot="share-bottom"
        class="m-share-order-bottom"
      >
        Tips: Share the bet on Groups and Forums where punters hang out, and your bet will have a greater chance of being followed!
      </div>
    </share>
  </div>
</template>

<script>
import anime from 'animejs'
import VButton from 'fe-vui/button'
import VDialog from 'fe-vui/dialog'
import toast from 'fe-vui/toast'
import { fetchShareOrderTime, fetchShareOrderUserValid } from '@ms/api/marketing'
import { messagesOfStakeBack } from '@ms/components/activity/stakeBack/stakeBack.config.js'
import useOrderDetail from '@ms/components/order/useOrderDetail.js'
import { getUrlOfShareTicket } from '@ms/components/activity/shareTicket'
import { drawHtml } from '@ms/utils/draw.js'
import lottie from 'lottie-web'
import uploadSharePics from 'wap/components/ShareTicket/uploadSharePics'
import { prefixLink } from '@ms/config/app'
import ShareWinning from './ShareWinning'
import Coins from '../components/Coins.vue'
import { Share, ShareTicket } from 'wap/components/index.js'
import modalHelper from '@ms/utils/scroll-fixed'
import { traceKol } from '@ms/utils/track.js'
import 'base/icons/svg/checked-select.svg'
import 'base/icons/svg/check-select.svg'
import 'base/icons/svg/png-x.svg'
import 'base/icons/svg/gantanhao.svg'

export default {
  name: 'PopupWinning',
  i18n: {
    messages: messagesOfStakeBack
  },
  components: {
    VButton,
    ShareWinning,
    Share,
    Coins,
    ShareTicket
  },
  props: {
    isShareElement: {
      type: Boolean,
      default: false
    },
    isShowCheckDetail: {
      type: Boolean,
      default: true
    },
    // 是否显示隐藏金额按钮
    hasHideAmountBtn: {
      type: Boolean,
      default: false
    },
    // 1代表Realsports，3为Jackpot，5为高频游戏，目前是轮盘赌
    bizType: {
      type: Number,
      default: 0
    },
    totalWinnings: {
      type: String,
      default: ''
    },
    shortId: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    pushTime: {
      type: Number,
      default: 0
    },
    canTopListShare: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const { resOrderDetail, getOrderDetail } = useOrderDetail()
    return { resOrderDetail, getOrderDetail }
  },
  data() {
    return {
      hideAmount: false, // 绘图组件是否隐藏金额
      hideAmountChecked: false, // 隐藏金额按钮是否勾选
      shareElement: null,
      shareVisible: false,
      shareTopTips: 'Click the picture to preview the shared content.',
      shareImgs: [], // 第一个元素为不隐藏金额，第二个元素为隐藏金额
      shareUrl: '',
      drawLoading: false,
      online: false, // stake back 活动是否在线
      userLimit: null, // 用户是否在黑名单
      isStakeShare: false, // 区分stakeback分享
      delayTimeList: [0.4, 0.6, 0.7, 0.9, 0.5, 0.9],
      rotateNumList: [0, 0, 0, -190, -90, -99]
    }
  },
  computed: {
    showWinnings() {
      const { totalWinnings } = this
      return +totalWinnings.replace(/,/g, '')
    },
    hasShowOff() {
      // 当中奖弹窗为Jackpot 的中奖弹窗时，不存在SHOW OFF 的按钮
      return this.bizType !== 3
    },
    fromTypeText() {
      switch (this.bizType) {
        case 1:
          return 'Sports Betting'
        case 3:
          return 'Jackpot'
        default:
          // no default
          return 'Others'
      }
    },
    hostname() {
      return location.hostname
    },
    shareText() {
      // 中奖弹窗一定是 已结算win状态
      let text = ''
      const { resOrderDetail, hideAmountChecked } = this
      if (resOrderDetail.totalStake) {
        if (hideAmountChecked) {
          text = 'This is my winning ticket on MSport, check the bet details and win together: '
        } else {
          text = `I just won ${this.$t('CURRENCY_UNIT')}${resOrderDetail.totalReturn} on MSport. This is my winning ticket, check the bet details and win together: `
        }
      }
      return text
    }
  },
  watch: {
    pushTime(val) {
      if (val) {
        this.resOrderDetail = {} // 重置订单详情（新的中奖弹窗请求接口请求订单详情）
        lottie.stop()
        setTimeout(() => {
          lottie.play()
          this.animeAmount()
        }, 500)
      }
    }
  },
  created() {
    // 是否在线 黑名单查询
    if (this.hasShowOff) {
      this.checkTime()
      this.getUserLimit()
    }
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$el,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: `${process.env.VUE_APP_CDN}lib/ribbon.json`
    })
    lottie.play()
    setTimeout(() => {
      lottie.play()
      this.animeAmount()
    }, 500)
  },
  methods: {
    animeAmount() {
      const amountStr = this.showWinnings.toString()
      const index = amountStr.indexOf('.') + 1 // 有无小数
      const length = amountStr.length - index // 小数个数
      const round = index ? Math.pow(-10, length) : 1 // 动画保留几位小数
      anime({
        targets: '.amount-con',
        innerHTML: [0, this.showWinnings],
        easing: 'linear',
        round
      })
    },
    toggleHideAmount() {
      this.hideAmountChecked = !this.hideAmountChecked
    },
    checkDetails() {
      const { orderId } = this
      if (this.bizType === 1) {
        location.href = prefixLink(`/my_bets/order_info?id=${orderId}`)
      } else if (this.bizType === 3) {
        location.href = prefixLink(`/jackpot/bets/${orderId}`)
      }
    },
    onHideAmount(status) {
      this.hideAmountChecked = status
    },
    // 分享前回调，上传图片
    callbackBeforeShare(index) {
      const { shareImgs, orderId } = this
      return uploadSharePics(orderId, 'prized', shareImgs[index])
    },
    async shareFn() {
      try {
        this.shareImgs = []
        this.drawLoading = true
        let ele = ''
        if (this.isStakeShare) {
          if (!this.resOrderDetail.orderId) {
            await this.getOrderDetail(this.orderId)
          }
          if (!this.shareContainer2) {
            ele = this.$refs.shareContainer2.$el
          }
        } else {
          if (!this.shareContainer) {
            ele = this.$refs.shareContainer.$el
          }
        }
        if (this.shareImgs.length < 2) {
          this.hideAmount = false
          const { data: image1 } = await drawHtml(ele)
          this.shareImgs.push(image1)
          this.hideAmount = true

          this.$nextTick(() => {
            // 隐藏金额图片
            drawHtml(ele, { scale: 2 }).then(({ data }) => {
              this.shareImgs.push(data)
              this.drawLoading = false
              this.shareVisible = true
            })
          })
        } else {
          this.drawLoading = false
          this.shareVisible = true
        }
      } catch (e) {
        this.drawLoading = false
        console.error(e)
      }
    },
    // 分享
    async handleShowOff(isStakeShare = false) {
      this.isStakeShare = isStakeShare
      const { orderId } = this
      this.shareUrl = traceKol(getUrlOfShareTicket(orderId, 'PRIZED'))

      // stake back share
      if (isStakeShare) {
        // 避免 user limit 状态未返回，导致判断失误
        if (typeof this.userLimit === 'object') {
          this.drawLoading = true
          await this.getUserLimit()
          this.drawLoading = false
        }
        if (this.userLimit) {
          return toast("Oops! You're not qualified.")
        } else {
          this.shareTopTips = ''
        }
      } else {
        this.shareTopTips = 'Click the picture to preview the shared content.'
      }
      this.shareFn()
    },
    onCloseShare() {
      this.shareVisible = false
    },
    closeDialog() {
      modalHelper.beforeClose()
      VDialog.close()
      this.$emit('close')
    },
    // 检查用户是否在黑名单
    async getUserLimit() {
      try {
        const data = await fetchShareOrderUserValid()
        this.userLimit = data
      } catch (error) {
        console.error(error)
      }
    },
    // 检查活动是否在线
    async checkTime() {
      try {
        const data = await fetchShareOrderTime()
        this.online = data.online
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.dialog-push.dialog-push-winning {
  .dialog {
    position: fixed;
    width: 100%;
    height: 100%;

    .dialog--main {
      height: 100%;
    }
  }
}
//main
.pop-winning {
  // display: none;
  position: fixed;
  z-index: 1;
  right: 0;
  bottom: 0;
  left: 0;
  width: 345/360 * 100%;
  max-width: 750px;
  margin: auto;
  animation: bounceInUp 1s;

  &-top {
    position: relative;
    z-index: 1;

    .cup {
      display: block;
      width: 143/@rem;
      margin: 0 auto;
    }

    .title {
      display: block;
      width: 274/@rem;
      margin: -35/@rem auto 0;
    }
  }

  &-main {
    position: relative;
    width: 100%;
    padding-top: 48/@rem;
    border-radius: 12px 12px 0 0;
    margin-top: -55/@rem;
    background-color: @white;
    color: #454645;
    text-align: center;

    .amount,
    .desc {
      box-sizing: border-box;
      padding: 0 10/@rem;
    }

    .amount {
      font-size: 32/@rem;
      font-weight: bolder;
    }

    .desc {
      font-size: 16/@rem;
      line-height: 34/@rem;
    }

    .close {
      position: absolute;
      z-index: 2;
      top: 5/@rem;
      right: 5/@rem;
      display: flex;
      width: 34/@rem;
      height: 34/@rem;
      align-items: center;
      justify-content: center;

      .svg-icon {
        color: @disabled;
        font-size: 24/@rem;
      }
    }
  }

  &-bot {
    width: 100%;
    height: 30/@rem;
    background: url("../images/winning/bot.png") no-repeat center / 100% 100%;
  }

  &-button {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 35/@rem auto 10/@rem;
    font-size: 16/@rem;

    .v-button {
      width: 160px;
      height: 49px;
      font-weight: bold;

      &.check {
        background: url("../images/winning/check.png") no-repeat center / 100% 100%;
        color: #c74409;
      }

      &.show {
        background: url("../images/winning/show.png") no-repeat center / 100% 100%;
        color: #1a531e;
      }
    }
  }

  &-coins1 {
    position: absolute;
    top: 21%;
    left: 17%;
    animation-delay: 0.3s;
  }

  &-coins2 {
    position: absolute;
    top: 35%;
    left: 24%;
    animation-delay: 0.8s;
  }

  &-coins3 {
    position: absolute;
    top: 22%;
    left: 42%;
    animation-delay: 0.5s;
  }

  &-coins4 {
    position: absolute;
    top: 32%;
    left: 50%;
    animation-delay: 0.7s;
    transform: rotateZ(-190deg);
  }

  &-coins5 {
    position: absolute;
    top: 23%;
    left: 66%;
    animation-delay: 0.4s;
    transform: rotateZ(-90deg);
  }

  &-coins6 {
    position: absolute;
    top: 39%;
    left: 64%;
    animation-delay: 0.9s;
    transform: rotateZ(-99deg);
  }
}

.popwin-coin {
  animation-duration: 1.5s;
  animation-name: coin_bounce;
  animation-timing-function: ease-in-out;
  opacity: 0;
  transform: translateY(50vh);
}

.m-winning-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  // background: rgba(0, 0, 0, 0.87);
  max-width: 750px;
  height: 100%;
  margin: auto;
  text-align: center;

  .m-share-stake-back {
    display: flex;
    width: 100%;
    height: 30/@rem;
    justify-content: center;
    background-color: @primary;
    color: @major;
    font-size: 12/@rem;
    line-height: 30/@rem;

    .myBets-stake-back-img {
      position: relative;
      top: -8/@rem;
      width: 36/@rem;
      margin-left: 6/@rem;
    }
  }

  .m-share-order {
    padding: 36/@rem 15/@rem 0;

    &-title {
      width: 100%;
      color: @major;
      font-size: 18/@rem;
      text-align: center;
    }

    &-content {
      width: 100%;
      margin: 8/@rem auto 0;
      color: @major;
      font-size: 14/@rem;
      line-height: 18/@rem;
      text-align: left;
    }

    &-tip {
      margin-top: 8/@rem;
      color: @major;
      font-size: 10/@rem;
      text-align: left;

      .svg-icon {
        color: @major;
        font-size: 18/@rem;
      }
    }

    &-bottom {
      width: 100%;
      box-sizing: border-box;
      padding: 15/@rem;
      margin: 0 auto;
      background-color: #ffefbf;
      color: #b2621b;
      font-size: 12/@rem;
      text-align: left;
    }

    .light {
      color: #fb751a;
    }
  }

  @keyframes coin_bounce {
    0%,
    100% {
      opacity: 0;
      transform: translateY(50vh);
    }

    15%,
    90% {
      opacity: 1;
    }

    50% {
      transform: translateY(0);
    }
  }

  @keyframes bounceInUp {
    0% {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }

    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }

    75% {
      transform: translate3d(0, 10px, 0);
    }

    90% {
      transform: translate3d(0, -5px, 0);
    }

    100% {
      transform: translate3d(0, 0, 0);
    }
  }
}

.m-winning-share.none-pad {
  .m-share-info {
    padding-top: 0;
  }
}

</style>
